import React from 'react';
import './palette.css'
import Text from "./Text";
import {LayoutChild} from "./Palette";
import {LoadIndicator} from 'devextreme-react/load-indicator';


function HeaderPage(props) {

    const {icon, text, load, textLoad} = props

    return (
        <div className="data-header">
            <LayoutChild center row>
                <i className={icon} style={{color: '#ffff', fontSize: 25}}/>
                <Text hover={false} text={text} color={'white'} left={7} size={18}/>
            </LayoutChild>
            {!load && <LayoutChild center row>
                <LoadIndicator height={20} width={20} elementAttr={{id: 'small-indicator'}}/>
                <Text hover={false} text={textLoad} color={'white'} left={7} size={9}/>
            </LayoutChild>}
        </div>
    )
}

export default HeaderPage


